define.alias("shared/components/shared/choose-your-upgrade", "calendar/components/shared/choose-your-upgrade");